var _path, _path2, _path3, _line, _line2, _line3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecognitionStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8482 38.1484H4.15179L3 43.1484H46L44.8482 38.1484Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9517 28.6497C28.9465 28.9808 32.0552 29.9742 35.0396 29.9742C38.0239 29.9742 40.7596 28.8705 42.1274 27.9875C42.7243 27.7226 43.4953 26.9941 43.6196 26.9941",
    stroke: "#FF8165",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2813 11.5717C36.2456 12.3687 38.2098 11.5717 38.2098 11.5717M38.2098 11.5717C38.2098 11.5717 41.3527 10.7747 41.3527 8.38361C41.3527 5.19553 39.7812 4 34.6741 4C29.9599 4 27.6028 5.35166 27.6028 8.38361C27.6028 10.6153 29.698 11.7045 30.7456 11.9702V19.1434C30.7456 21.1359 28.0433 22.4482 27.2099 22.73C26.0314 23.1285 24.46 24.324 24.46 25.9181C24.46 27.1933 24.46 29.9032 24.46 31.0987C24.8528 32.5599 27.3671 35.4823 34.2813 35.4823C41.1955 35.4823 43.7098 32.5599 44.1026 31.0987V25.9181C44.1026 24.9882 44.1026 23.527 42.5312 22.73C40.639 21.7702 37.817 21.1359 37.817 19.5419C37.817 18.2667 38.092 13.8299 38.2098 11.5717Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.0317,
    y1: 16.9766,
    x2: 24.103,
    y2: 16.9766,
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.2456,
    y1: 20.1699,
    x2: 23.3169,
    y2: 20.1699,
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4604,
    y1: 23.3594,
    x2: 18.6032,
    y2: 23.3594,
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8214 38.5331L46 43.1484H2L9.85714 13.1484H24.7857",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognitionStatusIcon);
export default __webpack_public_path__ + "static/media/RecognitionStatusIcon.7af3118abd883c41233d0e89012a9e04.svg";
export { ForwardRef as ReactComponent };